module.exports = __webpack_public_path__ + "img/other.84c4b183.svg";